import React from "react";

export default function Footer() {
  return <footer className="site-footer"><span>© {new Date().getFullYear()} Lander Central</span><span>Built for what’s next.</span></footer>;
}
